// import { FeedbackPanelConnection } from "../../components";

const FeedbackPanelConnections = () => {
  // return <FeedbackPanelConnection/>;
  return <></>;
};

export default FeedbackPanelConnections;
